var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.wrapClass }, [
    _c("img", {
      class: _vm.imgClass,
      style: _vm.imgStyle,
      attrs: { src: _vm.imgPath },
      on: { error: _vm.errorHandle }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-106de434", { render: render, staticRenderFns: staticRenderFns })
  }
}